import * as React from "react";
import { Link } from "react-router-dom";
import { Table, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import * as types from "../../../constants/actionTypes";
import TileLoader from '../../common/tileLoader';
import { debug } from "util";
import { rxRoute } from "../../../helpers/formatting";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";

class ArchivedPrescriptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showModel: false, selectedRx: null, SortColumn: "", SortDirection: "", rxArchivedList: this.props.archivedRxList };
        this.toggleModal = this.toggleModal.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.ArchivedPrescriptions.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isArchiveOrUnArchiveSuccess && nextProps.isLoggedIn) {
            this.props.getArchivedRxListData(); //refresh the archive list
            this.props.getRxListData();
        }
    }

    sort_by = (field, reverse, primer) => {
        var key = function (x) { return primer ? primer(x[field]) : x[field]; };

        return function (a, b) {
            var A = key(a), B = key(b);
            return ((A < B) ? -1 : ((A > B) ? 1 : 0)) * [-1, 1][+!!reverse];
        };
    }

    parseDate = (object) => {
        var ret;
        try {
            ret = Date.parse(object);
        }
        catch (e) {
            ret = 0;
        }
        if (ret === null || isNaN(ret) || object === "" || object === "N/A") {
            ret = 0;
        }
        return ret;
    }

    SelectSortBy = (e) => {
        try {
            var sSelected = e.target.value;
            if (sSelected === "NumberOfRefillsLeft")
                this.SortBy(sSelected, "number");
            else
                this.SortBy(sSelected);
        }
        catch (EE) {
        }
    }

    SortBy = (columnName, columnType) => {
        var sortDirection = "";
        var sortColumn = "";
        if (columnName === this.state.SortColumn) {
            if (this.state.SortDirection === "asc") {
                sortDirection = "desc";
            }
            else if (this.state.SortDirection === "desc") {
                sortDirection = "";
            }
            else {
                sortDirection = "asc";
            }
        }
        else {
            sortDirection = "asc";
            sortColumn = columnName;
        }

        var primer = "";

        if (columnType === "number") {
            primer = parseInt;
        }
        else if (columnType === "date") {
            primer = this.parseDate;
        }
        else {
            primer = function (x, y) {
                return (x === y) ? 0 : x ? -1 : 1;
            };
        }

        var sortData = this.props.archivedRxList;
        if (this.state.SortDirection !== "") {
            sortData = [].concat(this.state.rxArchivedList)
                .sort(this.sort_by(columnName, (sortDirection === "asc") ? true : false, !columnType ? function (a) { return a.toUpperCase() } : primer));
        }

        this.setState({
            rxArchivedList: sortData, SortDirection: sortDirection, SortColumn: sortColumn
        });
        logUI("MBHWeb.Rx.ArchivePrescriptionList.SortBy", new Date(), Tools.getURLPath(), JSON.stringify({ sortDirection: sortDirection, sortColumn: sortColumn }));
    }


    openModel(item) {
        this.setState({ showModel: true, selectedRx: item });
    }

    toggleModal() {
        this.setState({
            showModel: !this.state.showModel
        });
    }

    unarchiveRx(selectedRx) {
        logUI("MBHWeb.Rx.Prescription.UnArchive", new Date(), Tools.getURLPath(), JSON.stringify({ rxNumber: selectedRx.RxNumber, storeNumber: selectedRx.StoreNumber, IsArchive: false }));
        this.props.unArchivePrescription(selectedRx.RxNumber, selectedRx.StoreNumber, false);
        this.setState({ showModel: false, selectedRx: null });
    }

    render() {

        const { isArchivedRxListWaiting, archivedRxList, pharmacyError } = this.props;
        const { rxArchivedList } = this.state;

        return (
            <React.Fragment>
                <div className="rx-list rx-archived">
                    <div className="col-12">
                        <div className="row">
                            <div className="form-group list-sort col-12 d-lg-none">
                                <div className="il-group">
                                    <select className="form-control list-sort__dd" id="rxListSort_Archived" name="rxListSort" onChange={(e) => this.SelectSortBy(e)}>
                                        <option value="">Sort by</option>
                                        <option value="RxDrugName">Name</option>
                                        {/*<option value="Status">Status</option>*/}
                                        <option value="NumberOfRefillsLeft">Refills</option>
                                    </select>
                                    <div className="input-icon-append"><span className="icon-dd" /></div>
                                </div>
                            </div>
                            <div className="col-12 rx-list__column-headings d-none d-lg-block">
                                <div className="row">
                                    <div className="col-6 col-sm-8 col-md-10">
                                        <div className="row">
                                            <div className="col-3 col-lg-4">
                                                <button type="button" className="rxList-column-headings-title btn btn-sort-text" onClick={() => this.SortBy('RxDrugName')}>
                                                    NAME
                                                    <span className={(this.state.SortColumn !== 'RxDrugName') ? "icon-arrow-sm-down" : (this.state.SortDirection === 'asc') ? "icon-arrow-sm-up" : "icon-arrow-sm-down"} />
                                                </button>
                                            </div>
                                            <div className="col-3">
                                                <button type="button" className="rxList-column-headings-title btn btn-sort-text" onClick={() => this.SortBy('Status')}>
                                                    STATUS
                                                    {
                                                        /*<span className={(this.state.SortColumn !== 'Status') ? "icon-arrow-sm-down" : (this.state.SortDirection === 'asc') ? "icon-arrow-sm-up" : "icon-arrow-sm-down"} />*/
                                                    }
                                                </button>
                                            </div>
                                            <div className="col-2">
                                                <button type="button" className="rxList-column-headings-title btn btn-sort-text" onClick={() => this.SortBy('DateIssued', 'date')}>
                                                    DATE ISSUED
                                                    <span className={(this.state.SortColumn !== 'DateIssued') ? "icon-arrow-sm-down" : (this.state.SortDirection === 'asc') ? "icon-arrow-sm-up" : "icon-arrow-sm-down"} />
                                                </button>
                                            </div>
                                            <div className="col-2">
                                                <button type="button" className="rxList-column-headings-title btn btn-sort-text" onClick={() => this.SortBy('LastFilledDate', 'date')} >
                                                    LAST FILLED
                                                    <span className={(this.state.SortColumn !== 'LastFilledDate') ? "icon-arrow-sm-down" : (this.state.SortDirection === 'asc') ? "icon-arrow-sm-up" : "icon-arrow-sm-down"} />
                                                </button>
                                            </div>
                                            <div className="col-2 col-lg-1 refill-col-span">
                                                <button type="button" className="rxList-column-headings-title refill-col-span btn btn-sort-text" onClick={() => this.SortBy('NumberOfRefillsLeft', 'number')}>
                                                    REFILLS
                                                    <span className={(this.state.SortColumn !== 'NumberOfRefillsLeft') ? "icon-arrow-sm-down" : (this.state.SortDirection === 'asc') ? "icon-arrow-sm-up" : "icon-arrow-sm-down"} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-2 text-center">
                                        <button type="button" className="rxList-column-headings-title btn btn-sort-text">
                                            UNARCHIVE
                                            {/*
                                                <span onClick={() => this.SortBy('CanBeArchived', 'bool')} className={(this.state.SortColumn != 'CanBeArchived') ? "icon-arrow-sm-down" : (this.state.SortDirection == 'asc') ? "icon-arrow-sm-down" : "icon-arrow-sm-down"} />
                                            */}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {rxArchivedList && rxArchivedList.length > 0 &&
                            rxArchivedList.map((item, key) =>
                                (<div key={key} className="rx-list__item">
                                    <div className="row d-flex align-items-stretch rx-mobile-row">
                                        <div className="col-12 col-lg-10 rx-list__item--prescription">
                                            <div className="row">
                                                <div className="col-12 col-sm-6 col-lg-4">
                                                    {item.RxDrugName}
                                                    <div className="rx-list__item--number"><span>Rx No.</span>{item.RxNumber}</div>
                                                </div>

                                                <div className="col-12 col-sm-3 col-lg-3 d-none d-sm-block rx-mobile-row__item">{item.Status}</div>
                                                <div className="col-lg-2 d-none d-lg-block">{item.DateIssued}</div>
                                                <div className="col-lg-2 d-none d-lg-block">{item.LastFilledDate ? item.LastFilledDate : 'Not Available'}</div>
                                                <div className="col-12 col-sm-3 col-lg-1 rx-mobile-row__item"><div className="d-inline d-sm-none">Refills: </div>{item.NumberOfRefillsLeft}</div>
                                            </div>
                                            <Link className="list-item-block-link" aria-label={"View " + item.RxDrugName + " details"} to={{ pathname: `${rxRoute('rxDetail')}/${item.StoreNumber}/${item.RxNumber}` }}><span /></Link>
                                        </div>
                                        <button type="button" aria-label={"Unarchive" + item.RxDrugName} onClick={() => this.openModel(item)} className="col-lg-2 d-none d-lg-block rx-list__item--unarchive btn btn-icon-only">
                                            <span className="icon-unarchive" />
                                        </button>
                                    </div>
                                </div>)
                            )
                        }

                    </div>

                </div>
                {this.state.showModel
                    ? <Modal className="verify-modal" isOpen={this.state.showModel} toggle={this.toggleModal} centered>
                        <ModalBody>
                            <div className="row">
                                <div className="col-12">
                                    <p>Are you sure you want to unarchive this prescription?</p>
                                    <div className="row link-container">
                                        <div className="col-6 link-left">
                                            <button type="button" className="btn btn-link-style" onClick={() => this.unarchiveRx(this.state.selectedRx)}>YES</button>
                                        </div>
                                        <div className="col-6 link-right">
                                            <button type="button" className=" btn btn-link-style" onClick={this.toggleModal}>NO</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                     </Modal>
                    : ''
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        isArchivedRxListWaiting: state.pharmacy.isArchivedRxListWaiting,
        pharmacyError: state.pharmacy.archivedRxListError,
        archivedRxList: state.pharmacy.archivedRxList,
        isArchiveOrUnArchiveSuccess: state.pharmacy.isArchiveOrUnArchiveSuccess,
        userDetails: state.sso.userDetails,
        isLoggedIn: state.sso.isLoggedIn
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getRxListData: () => dispatch({ type: types.LOAD_RX_LIST_START }),
        getArchivedRxListData: () => dispatch({ type: types.LOAD_ARCHIVED_RX_LIST_START }),
        unArchivePrescription: (rxNumber, storeNumber, archive) => dispatch({
            type: types.ARCHIVE_UNARCHIVE_RX_START,
            payload: { rxNumber: rxNumber, storeNumber: storeNumber, archive: archive }
        })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ArchivedPrescriptions);